import Avatar from "../../../assets/Avatar.png";
import CoursePlaceholder from "../../../assets/CoursePlaceholder.png";
import ThreeDotsIcon from "../../Icons/ThreeDotsIcon";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getUserCountry } from "../../../utils/utils";
import ReactMarkdown from 'react-markdown';
import { Book } from "../../../types/types";
import BookDropdown from "./BookDropdown";
interface BookCardProps {
  book: Book;
}

const BookCard = ({ book }: BookCardProps) => {
  const [showFullDescription] = useState(false);
  const descriptionWords = book.description.split(" ");

  const truncatedDescription = showFullDescription
    ? descriptionWords.join(" ")
    : descriptionWords.slice(0, 25).join(" ");
  const [country, setCountry] = useState<string | null>(null);

  useEffect(() => {
    const userCountry = getUserCountry();
    setCountry(userCountry);
  }, []);

  return (
    <div className="group relative flex w-full flex-col justify-between overflow-visible rounded-2xl border border-black/10 bg-white p-4 shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_22px_55px_rgba(17,24,22,0.12)]">
      <div className="relative mb-4">
        <Link to={`/book/${book.slug}`}>
          <img
            className="aspect-[4/3] w-full rounded-xl border border-black/5 object-cover transition duration-300 group-hover:scale-[1.015]"
            src={book.img_url || CoursePlaceholder}
            alt="Course"
          />
        </Link>
      </div>
      <div>
        <div className="flex justify-between w-full items-center mb-3 py-0.5">
          <h1 className="min-w-0 text-xl font-bold text-textPrimary">{book.name}</h1>
          <div className="flex min-w-[90px] items-center justify-center gap-0.5 rounded-xl bg-primary px-3 py-1.5 font-bold text-white">
            {country === "EG" ? (
              <>
                {" "}
                {book.public_EGP_price}{"  "}
                <span className="text-sm uppercase">EGP</span>
              </>
            ) : (
              <>
                {book.public_USD_price}{" "}
                <span className="text-sm uppercase">USD</span>
              </>
            )}
          </div>
        </div>
        <div className=" mb-4">
          <span className="text-sm font-medium text-lightGray">
            <ReactMarkdown>{truncatedDescription}</ReactMarkdown>
          </span>
          {!showFullDescription && (
            <Link
              className="text-sm font-bold text-primary"
              to={`/book/${book.slug}`}
            >
              {" "}
              &nbsp; Learn more about {book.name}
            </Link>
          )}
        </div>
        <div className="flex gap-2 items-center mb-4">
          <img
            src={book.author?.photo || Avatar}
            className="max-w-5 max-h-5 w-full h-full object-cover rounded-full object-[75%_25%]"
            alt="Instructor Avatar"
          />
          <h1 className="text-xs font-medium text-textPrimary">
            {book.author?.firstName} {book.author?.lastName}{" "}
            <span className="opacity-70">from</span> {book.author?.city},{" "}
            {book.author?.country}
          </h1>
        </div>
        <div className="absolute bottom-4 right-4 z-10">
          <BookDropdown bookId={book.id || ''} slug={book.slug || ''}>
            <ThreeDotsIcon />
          </BookDropdown>
        </div>
      </div>
    </div>
  );
};

export default BookCard;
